
import React, { Fragment, useState } from 'react';
import ButtonIcon from '@visa/vds/button-icon';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Icon from '@visa/vds/icon';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import Radio from '@visa/vds/radio';
import RadioErrorMessage from '@visa/vds/radio-error-message';
import RadioGroup from '@visa/vds/radio-group';
import RadioGroupControl from '@visa/vds/radio-group-control';
import RadioGroupLegend from '@visa/vds/radio-group-legend';
import Checkbox from '@visa/vds/checkbox';
import CheckboxErrorMessage from '@visa/vds/checkbox-error-message';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import CheckboxSet from '@visa/vds/checkbox-set';
import CheckboxSetLegend from '@visa/vds/checkbox-set-legend';
import DateSelector from '@visa/vds/date-selector';
import enUS from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import { ProductSelectionConst } from '../ProductSelectionLogic';

const VSTTSubscriptionComponent = (props) => {

    const handleEnvironmentSelected = (environment) =>{
        if (props.selectedEnvironments.find(x => x == environment) == undefined){
            props.setSelectedEnvironments([...props.selectedEnvironments,environment].sort());
        }else{
            props.setSelectedEnvironments(props.selectedEnvironments.filter((item) => item !== environment).sort())
        }
    } 

    const handleAudienceSelected = (audience) =>{
        props.handleVSTTAudienceSelected(!audience)
        props.setSelectedEnvironments(props.selectedEnvironments.filter((item) => 
            (item !== props.AUDIENCE_PREPROD_ID && item !== props.AUDIENCE_PROD_ID)
        ).sort())
    }

    return (
        <>
            <Row className="store-product-details-row">
                <Col lg={8}>
                    <CheckboxSet>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    id={props.id + "SubscriptionCheckbox"}
                                    checked={props.selectedVSTTAudience}
                                    name="checkbox-subscription-select"
                                    label={props.subscriptionLabel}
                                    value={props.AUDIENCE_IDENTIFIER}
                                    onChange={() => { handleAudienceSelected(props.selectedVSTTAudience)}}
                                />
                                <Typography className="select-product-caption" variant='body'>{props.subscriptionCaption}</Typography>
                            </CheckboxListItem>
                        </CheckboxList>
                        <CheckboxErrorMessage id="single-validation-error-message">
                            {
                                props.showVSTTProductAudienceErrorMessage && props.showVSTTProductAudienceErrorMessage === true
                                    ? <><Icon
                                        name="error"
                                        resolution="tiny"
                                    />Please select one Product Type</>
                                    : ''
                            }
                        </CheckboxErrorMessage>
                    </CheckboxSet>
                </Col>
                {props.selectedVSTTAudience && props.selectedVSTTAudience && 
                    <Col lg={3}>
                    <CheckboxSet>
                        <CheckboxSetLegend>Environment</CheckboxSetLegend>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    id={props.id + "ProductionCheckbox"}
                                    name="checkbox-env-select"
                                    label={"Production"}
                                    value={props.AUDIENCE_PROD_ID}
                                    onChange={() => handleEnvironmentSelected(props.AUDIENCE_PROD_ID)}
                                />
                            </CheckboxListItem>
                            <CheckboxListItem>
                                <Checkbox
                                    id={props.id + "PreProductionCheckbox"}
                                    name="checkbox-env-select"
                                    label={"Pre-Production"}
                                    value={props.AUDIENCE_PREPROD_ID}
                                    onChange={() => handleEnvironmentSelected(props.AUDIENCE_PREPROD_ID)}
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                        <CheckboxErrorMessage id="single-validation-error-message-environment">
                            {
                                props.showVSTTProductEnvironmentErrorMessage && props.showVSTTProductEnvironmentErrorMessage === true
                                    ? <><Icon
                                        name="error"
                                        resolution="tiny"
                                    />Please select at least one Environment</>
                                    : ''
                            }
                        </CheckboxErrorMessage>
                    </CheckboxSet>
                    </Col>
                }

            </Row>
        </>
    )
}

export default VSTTSubscriptionComponent;